export const formatDatetimeToTimePart = (date: Date | string): string =>
  formatDatetime(date, "HH:mm");
